import React, { useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import axios from 'axios';
import MeetLink from '../../pages/MeetLink';

export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}

export default function PreJoinScreens() {
  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { URLRoomName }: any = useParams();
  const [step, setStep] = useState(Steps.roomNameStep);
  const [generatedLink, setGeneratedLink] = useState('');
  const [name, setName] = useState<string>(user?.displayName || '');
  const [roomName, setRoomName] = useState<string>('');

  const [mediaError, setMediaError] = useState<Error>();

  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
      //   if (user?.displayName) {
      setStep(Steps.deviceSelectionStep);
      //   }
    }
  }, [user, URLRoomName]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log('Error acquiring local media:');
        console.dir(error);
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const endpoint = process.env.REACT_APP_TOKEN_ENDPOINT + 'scheduleCall';
    axios.post(endpoint, { roomName: roomName, createdBy: 1, participant: 2 }).then(({ data }) => {
      setGeneratedLink(data.generatedLink);
      //   if (!window.location.origin.includes('twil.io')) {
      //     window.history.replaceState(
      //       null,
      //       '',
      //       window.encodeURI(`/room/${data['room_name']}${window.location.search || ''}`)
      //     );
      //   }
      //   setStep(Steps.deviceSelectionStep);
    });
  };

  return (
    <IntroContainer>
      {generatedLink ? (
        <MeetLink link={generatedLink} />
      ) : (
        <>
          <MediaErrorSnackbar error={mediaError} />
          {step === Steps.roomNameStep && (
            <RoomNameScreen
              name={name}
              roomName={roomName}
              setName={setName}
              setRoomName={setRoomName}
              handleSubmit={handleSubmit}
            />
          )}

          {step === Steps.deviceSelectionStep && (
            <DeviceSelectionScreen name={name} roomName={roomName} setStep={setStep} />
          )}
        </>
      )}
    </IntroContainer>
  );
}
